var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.183,
    height: 17.133,
    viewBox: "0 0 23.183 17.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye",
    "data-name": "Icon feather-eye",
    transform: "translate(-1 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41743",
    "data-name": "Path 41743",
    d: "M1.5,14.067S5.533,6,12.592,6s11.092,8.067,11.092,8.067-4.033,8.067-11.092,8.067S1.5,14.067,1.5,14.067Z",
    transform: "translate(0 -6)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41744",
    "data-name": "Path 41744",
    d: "M19.55,16.525A3.025,3.025,0,1,1,16.525,13.5,3.025,3.025,0,0,1,19.55,16.525Z",
    transform: "translate(-3.933 -8.458)",
    fill: "#000000",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.a1d3e08de02c75fb701d99fb76c4ba7f.svg";
export { ForwardRef as ReactComponent };